import { render } from "./azuread.vue?vue&type=template&id=20b7e1c1"
import script from "./azuread.vue?vue&type=script&lang=js"
export * from "./azuread.vue?vue&type=script&lang=js"

import "./azuread.vue?vue&type=style&index=0&id=20b7e1c1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__